import React from "react";
import SvgIcon, {SvgIconProps} from "@material-ui/core/SvgIcon";
import {CardBody} from "view/images/PaymentStatusIcon";

const CardIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="-1 -1 18 18">
    <CardBody color="currentColor" />
  </SvgIcon>
);

export default CardIcon;
